define('pages/templates/templates_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/htmlad/templates/htmlad_templates_view',

  'text!./templates_page_template.html'

], function (Backbone, $, _,
             HtmlAdTemplatesView,
             templates_page_template) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function (opts) {
      _.extend(this, opts);

      this.subViews = [];

      this.templates = new HtmlAdTemplatesView(this.params);
      this.subViews.push(this.templates);

      this.render();

      this.renderSubView();
    },

    template: _.template(templates_page_template),
    subViews: [],

    events: {
      'click .js-toggle-infotext': 'toggleInfoText'
    },

    toggleInfoText: function() {
      this.$('.icon.icon-chevron-up').toggleClass('hide');
      this.$('.icon.icon-chevron-down').toggleClass('hide');
      this.$('.panel-info-text').toggleClass('hide');
    },

    render: function () {

      this.$el.html(this.template());

      return this;
    },

    renderSubView: function () {
      this.$('.templates-page-content').html(this.templates.$el);
      // To get text as html and get the bold text
      this.$('#infotext2_2').html(_.t('htmlad_template.infotext2_2'));
      this.$('#infotext2_3').html(_.t('htmlad_template.infotext2_3'));
      this.$('#infotext3').html(_.t('htmlad_template.infotext3'));
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

